import { Directive, inject } from '@angular/core';
import { ModalService } from '@df/ui/modal/modal.service';
import { ICmsModalOpenDirective } from '@icms/client/assets/modal/icms-modal-open.directive';
import { NMultisiteModal } from './multisite-modal.interfaces';

@Directive({
    selector: '[multisiteModalOpen]',
    standalone: true
})
export class MultisiteModalOpenDirective extends ICmsModalOpenDirective {
    override iCmsModalOpen = NMultisiteModal.componentId;

    protected modalService = inject(ModalService);

    protected override _onClick(): void {
        this.modalService.closeAll();

        super._onClick();
    }
}
